export default "__VITE_ASSET__DO$brmy9__"